<template>
    <div>
        <v-row>
            <v-col cols="12" md="4" align="left">
                <div class="subtitle-2"><b>{{ $t('group_name') }}</b></div>
                <v-text-field
                    :value.sync="group_name"
                    @change="(val) => onchange('group_name',val)"
                    outlined
                    class="mt-1"
                    :disabled="disabled"
                ></v-text-field>
            </v-col>
        </v-row>
        
        <v-row>
            <v-col cols="12" md="8" align="left">
                <div class="subtitle-2"><b>{{ $t('group_extranote') }}</b></div>
                <v-textarea
                    :value="group_extranote"
                    @change="(val) => onchange('group_extranote',val)"
                    class="mt-1"
                    outlined
                    :disabled="disabled"
                ></v-textarea>
            </v-col>
        </v-row>
    </div>
</template>
<script>
  export default {
    props: ['group_name','group_extranote','onchange','disabled'],
    data () {
        return {

        }
    }
  }
</script>